'use client'

import { Component } from 'react'
import type { ReactNode } from 'react'

interface AdSlotErrorBoundaryProps {
  children: ReactNode
}

interface AdSlotErrorBoundaryState {
  hasError: boolean
}

/**
 * Lightweight error boundary for ad slots.
 * Renders nothing on error to prevent ad failures from crashing the page.
 */
export class AdSlotErrorBoundary extends Component<
  AdSlotErrorBoundaryProps,
  AdSlotErrorBoundaryState
> {
  constructor(props: AdSlotErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): AdSlotErrorBoundaryState {
    return { hasError: true }
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null
    }

    return this.props.children
  }
}
